// Shared react-tooltip ids. Use a small fixed number of global <Tooltip>
// instances (mounted once in App) instead of rendering one per anchor.
// Rendering hundreds of <Tooltip> components attaches that many global DOM
// listeners and causes app-wide flicker on mouse move.
export const APP_TOOLTIP_ID = "app-tooltip";
export const APP_ERROR_TOOLTIP_ID = "app-error-tooltip";
